const alpha = Array.from(Array(26)).map((_, i) => i + 65);
export const ALPHABET = alpha.map((x) => String.fromCharCode(x));
export const PAGINATE_ALL_LIMIT = 10000;

// Vehicle type group codenames — shared across `connect` (setting templates) and `purchase`
// (search engine), so they live in `common` rather than in one feature area.
export const DEFAULT_VEHICLE_TYPE = 'TC4';
export const COMPLETE_WHEEL_VEHICLE_TYPE = 'WCW';
// Stored in a setting template's default homologations for "no homologation"; the search result
// filter uses '' for the same option (WCT-5284).
export const NO_HOMOLOGATION = 'NONE';
export const SUPPORT_EMAIL = 'contact@wyzgroup.com';
